import { Component, Renderer2, ViewChild, ElementRef, OnInit, ViewChildren, QueryList } from '@angular/core';
import { AuthService } from './auth/auth.service';
import { MatMenuTrigger, MatMenu } from '@angular/material/menu';

export const publicMenuList = [{
  id: 10,
  label: 'HOME',
  children: [],
  route: ''
},
{
  id: 20,
  label: 'CHI SIAMO',
  children: [],
  route: 'chisiamo'
},
{
  id: 30,
  label: 'AREE TEMATICHE',
  children: [{
    label: 'Acque',
    children: [],
    route: 'acque',

    /*
            label2: 'TESTING',
            route2: 'https://www.google.it/'
    */

  }, {
    label: 'Agenti Fisici',
    children: [],
    route: 'agentifisici'
  }, {
    label: 'Aria',
    children: [],
    route: 'aria'
  }, {
    label: 'Conservazione Natura',
    children: [],
    route: 'conservazionenatura'
  }, {
    label: 'Energia',
    children: [],
    route: 'energia'
  }, {
    label: 'Rifiuti',
    children: [],
    route: 'rifiuti'
  }, {
    label: 'Territorio',
    children: [],
    route: 'territorio'
  }]
},
{
  id: 40,
  label: 'IO SONO',
  children: [{
    label: 'Cittadino',
    children: [],
    route: 'cittadino'
  }, {
    label: 'Impresa/Professionista',
    children: [],
    route: 'impresaprofessionista'
  }, {
    label: 'Operatore',
    children: [],
    route: 'operatore'
  }, {
    label: 'Delegato',
    children: [],
    route: 'delegato'
  }]
},
{
  label: 'NEWS',
  children: [],
  href: 'https://portal.sardegnasira.it/news'
},
/*
{
  id: 50,
  label: 'SERVIZI ONLINE',
  children: [{
      label: 'Cartografia',
      children: [],
      href: '/cartografia'
    }, {
      label: 'Indicatori Ambientali',
      children: [],
      route: 'indicatoriambientali'
    }, {
      label: 'Gestione Procedimenti Amministrativi (GPA)',
      children: [],
      route: 'gestioneprocedimentiamministrativi'
    }, {
      label: 'Monitoraggi Ambientali',
      children: [],
      route: 'monitoraggiambientali'
    }, {
      label: 'Geoportale',
      children: [],
      route: 'geoportale'
    }]
},
*/

{
  label: 'DATI AMBIENTALI',
  children: [],
  href: 'https://portal.sardegnasira.it/dati-ambientali'
},

/*
{
  id: 50,
  label: 'DATI APERTI',
  children: [],
  route: 'datiaperti'
},
*/
{
  id: 51,
  label: 'DATI APERTI',
  children: [/*{
    label: 'ELENCHI',
    children: [],
    route: 'elenchi'
  }, {
    label: 'DATI CARTOGRAFICI',
    children: [],
    route: 'daticartografici'
  }, */{
    label: 'NORMATIVA',
    children: [],
    route: 'normativa'
  }],
  route: 'datiaperti'
},


{
  id: 60,
  label: 'MAPPA PORTALE',
  children: [],
  route: 'mappaportale'
}];


export var areeTematiche = [];


declare var $: any;
declare function trackMenu(): any;


/**
 * @title Nested menu
 */
@Component({
  selector: 'nested-menu',
  templateUrl: 'menu.html',
  styleUrls: ['./menu.css']
})
export class NestedMenu {
  menuList: Array<any>;

  //	@ViewChild('wth2', { read: ElementRef }) private levelOne: ElementRef;
  //@ViewChildren('levelOneTrigger') levelOneTriggers: QueryList<MatMenuTrigger>;

  constructor(private ren: Renderer2, private authService: AuthService) {
    if (authService.isUserAuthenticated()) {
      this.menuList = authService.getMenu();
      this.menuList.unshift({ label: 'HOME PRIVATA', children: [], route: '' });

      this.menuList.forEach(menuItem => {
        console.log(menuItem.id);

        if (menuItem.id == 200) {
          this.addChildren2AreaTematiche(areeTematiche, menuItem.children);
        }
      });
    }
    else
      this.menuList = publicMenuList;
  }

  addChildren2AreaTematiche(menuArr, children) {
    if (children && children.length) {
      children.forEach(area => {
        if (area.label2) {
          let subarea = [];
          this.addChildren2AreaTematiche(subarea, area.children);

          menuArr.push({
            "id": area.id,
            "label": area.label,
            "title": area.title,
            "route": area.route,
            "href": area.href,
            "behavior": area.behavior,
            "icon": area.icon,
            "label2": area.label2,
            "title2": area.title2,
            "route2": area.route2,
            "href2": area.href2,
            "behavior2": area.behavior2,
            "icon2": area.icon2,
            "children": subarea
          });
        }
      });
    };
  }

  buttonEnter(trigger) { }
  buttonLeave(trigger, event) { }
  menuenter(levelOneTrigger) { }
  menuLeave(levelOneTrigger) { }
  menu2enter(levelOneTrigger) { }
  menu2Leave(levelOneTrigger) { }
  menu3enter(levelOneTrigger) { }
  menu3Leave(levelOneTrigger) { }

  gotoWindow(where) {
    /*
    if(where&&where.startsWith('http'))
      window.open(where);
    else
    */
    window.location.href = where;
  }
}

